export default "__VITE_ASSET__Cl3XKIu6__"